import {useEffect, useRef, useState} from "react"
import {setTrack} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {Button, Switcher} from "parts";
import Cookies from "js-cookie";
import {useParams} from "react-router-dom";


const CookieEnum = Object.freeze({
  necessary: 0,
  preference: 1,
  analytics: 2,
  marketing: 3,
})


export const CookiesBanner = () => {
  const
    {t} = useTranslation('common', {keyPrefix: 'cookies'}),
    {uid} = useParams()

  // const A50 = useCookieYes()

  const
    [consents, setConsents] = useState(Cookies.get('consents') ? JSON.parse(Cookies.get('consents')) : [CookieEnum.necessary]),
    [cookies, setCookies] = useState(
      // true
      (+window.localStorage.getItem('cookies') > 0 || Cookies.get('consents')) === true
        ? false
        : undefined
    ),
    [settings, setSettings] = useState(false),
    [fading, setFading] = useState(true),
    lastScrollTop = useRef(0)

  useEffect(() => {
    window.asked =
      // A50.value === 'B' ||
      // [LandingEnum.accent].includes(window.landing) ||
      uid ||
      window.location.href.match(/\/(friday|discount)(?:\/|[?#].*|$)/) !== null

    window.askConsent = (ask) => {
      // console.log('window.askConsent', ask, window.asked, cookies)

      if (window.asked || cookies !== undefined)
        return

      window.asked = true

      clearTimeout(window.consentTimeout)

      if (!ask) {
        // const d = window.dataLayer
        //
        // if (d[0][0] === 'consent') {
        // if (
        //   d[1][0] === 'js' &&
        //   (d[1][1].getTime() + d[0][2].wait_for_update > (new Date()).getTime())
        // ) {
        //   console.log('remove consent')
        //   window.dataLayer.shift() // remove consent
        // } else {
        //   console.warn('ask timeout consent')
        acceptConsent()
        // }
        // }
      }
      // else if (window.landing !== LandingEnum.adhd) {
      //   // for A
      //   setExperiment(A50)
      //   getExperiment('A50')
      // }

      // if (cookies === undefined)
      setCookies(ask)

      delete window.askConsent
    }

    const cookiesStore = +window.localStorage.getItem('cookies')

    if (Cookies.get('consents'))
      acceptConsent()
    else if (cookiesStore > 0) {
      if (cookiesStore > 1)
        acceptConsent()

      delete window.askConsent
    } else {
      const asked = +window.sessionStorage.getItem('ask_consent')

      if (asked > 0) {
        // console.log('from session')
        window.askConsent(asked > 1)
      } else {
        window.consentTimeout = setTimeout(() => {
          console.warn('timeout consent')
          acceptConsent()
        }, 5000)
      }
    }

    return () => delete window.askConsent

    // document.addEventListener("cookieyes_banner_load", function (eventData) {
    //   const data = eventData.detail
    //   console.log('cookieyes_banner_load', data)
    //
    //   if (data.activeLaw) {
    //     setExperiment(A50)
    //     getExperiment('A50')
    //   }
    // })
    //
    // document.addEventListener("cookieyes_consent_update", function (eventData) {
    //   const data = eventData.detail
    //   console.log('cookieyes_consent_update', data)
    //
    //   setTrack(data.accepted?.length > 1 ? 'cta_cookies_accept' : 'cta_cookies_reject')
    // })
  }, [])

  const
    A79 =
      // i18n.resolvedLanguage === 'en' &&
      cookies
        ? {name: 'A79', value: 'B'}
        : {name: 'A79', value: 'A'}
      // i18n.resolvedLanguage === 'en' && cookies &&
      // window.landing === LandingEnum.default &&
      // window.location.href.match(/\/(friday|discount)(?:\/|[?#].*|$)/) === null
      //   ? getExperiment('A79')
      //   : {name: 'A79', value: 'A'}

  const acceptConsent = (newConsents) => {
    if (
      // A50.value === 'B' ||
      !window.gtag ||
      window.dataLayer[0][0] !== 'consent'
    )
      return

    delete window.consentTimeout

    const grants =
      A79.value !== 'A'
        ? {
          functionality_storage: 'granted',
          security_storage: 'granted',
        }
        : {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
          personalization_storage: 'granted',
          functionality_storage: 'granted',
          security_storage: 'granted',
        }

    const list = newConsents || consents
    list.forEach((key) => {
      switch (key) {
        case CookieEnum.preference:
          grants.personalization_storage = 'granted'
          break

        case CookieEnum.analytics:
          grants.analytics_storage = 'granted'
          break

        case CookieEnum.marketing:
          grants.ad_storage = 'granted'
          grants.ad_user_data = 'granted'
          grants.ad_personalization = 'granted'
          break
      }
    })

    // console.log('acceptConsent', grants, list)
    window.gtag('consent', 'update', grants)
  }

  const handleSave = (items) => {
    if (!items) {
      // window.localStorage.setItem('cookies', '2')
      setCookies(false)
      setTrack('cta_cookies_save')
    }

    const isLocalhost = window.location.hostname === 'localhost'

    Cookies.set('consents', JSON.stringify(items || consents), {
      expires: 365,
      domain: isLocalhost ? undefined : '.vocalimage.net',
      path: '/',
      sameSite: 'Lax'
    })

    acceptConsent(items)
  }

  const handleCookies = (accept) => {
    if (accept) {
      if (A79.value !== 'A') {
        // setConsents(Object.values(CookieEnum))
        // acceptConsent(Object.values(CookieEnum))
        handleSave(Object.values(CookieEnum))
      } else
        acceptConsent()
    }

    window.localStorage.setItem('cookies', accept ? '2' : '1')
    setCookies(false)

    setTrack(accept ? 'cta_cookies_accept' : 'cta_cookies_reject')
  }

  if (!cookies)
    return


  if (A79.value === 'A') {
    const btnStyle = {
      padding: '0.5rem',
      fontSize: '0.75rem',
      lineHeight: '1rem'
    }

    return (
      <div style={{position: 'fixed', zIndex: 50, bottom: '0.5rem', left: '50%', transform: 'translate(-50%)', width: '100%', maxWidth: 'var(--max-width)', padding: '0 0.5rem'}}>
        <div className={'panel small-sm'} style={{lineHeight: '1rem', padding: '1rem', borderRadius: '0.5rem'}}>
          <p className={'mb-2'}>{t('text')}</p>
          <div className={'row md'}>
            <Button variant={'secondary'} style={{...btnStyle, color: 'var(--secondary-yellow)'}} onClick={() => handleCookies(false)}>{t('reject')}</Button>
            <Button variant={'gold'} style={btnStyle} onClick={() => handleCookies(true)}>{t('accept')}</Button>
          </div>
        </div>
      </div>
    )
  }



  const handleScroll = (e) => {
    const
      target = e.currentTarget,
      scrollTop = target.scrollTop,
      maxScroll = target.scrollHeight - target.clientHeight

    if (scrollTop >= maxScroll - 1)
      setFading(false)
    else if (scrollTop < lastScrollTop.current)
      setFading(true)

    lastScrollTop.current = scrollTop
  }

  const handleChange = (key, checked) =>
    setConsents(prev => {
      if (checked)
        return [...prev, key]
      else
        return prev.filter(item => item !== key)
    })

  return (
    <>
<style>{
`.cookies { position: fixed; z-index: 50; bottom: 0; left: 0; width: 100%; background-color: var(--bg-80); color: #D1D1D1; line-height: 20px }
.cookies .content, .cookies > .buttons, .cookies > .header { padding: 1.25rem }
.cookies.row:not(.active) .content { padding-right: 0 }
.cookies.row:not(.active) .buttons { padding-left: 0 }
.cookies > .buttons { flex-direction: row }
.cookies.active > .buttons, .cookies > .header { background-color: var(--bg-70) }
.cookies > .buttons .btn { font-size: 14px }
.cookies > .buttons .btn-secondary { color: var(--white-100); background-color: var(--bg-50) }
.cookies.active { display: flex; flex-direction: column }
.cookies.active .content { overflow: hidden }
.cookies.active .scrollable { height: calc(100% - 22px) }
.fading { position: absolute; left: 0; width: 100%; margin-top: -53px; height: 72px; pointer-events: none; background: linear-gradient(0deg, #121212 0%, rgba(18, 18, 18, 0) 100%); }

.switcher { position: relative; display: inline-block; width: 40px; height: 24px }
.switcher input { opacity: 0; width: 0; height: 0 }
.slider-switch { position: absolute; cursor: pointer; background-color: rgba(209, 209, 209, 0.2); border-radius: 20px; top: 0; left: 0; right: 0; bottom: 0; transition: 0.4s }
.slider-switch::before { position: absolute; content: ""; height: 16px; width: 16px; left: 4px; bottom: 4px; background-color: #D1D1D1; border-radius: 50%; transition: 0.4s }
input:checked + .slider-switch { background-color: #3062D4 }
input:checked + .slider-switch::before { transform: translateX(16px) }

@media (max-width: 991px) {
  .cookies.active { top: 0; height: calc(100vh); max-height: 100% }
  .cookies.active .content { height: 100% }
  .cookies > .buttons { flex-wrap: wrap }
  .cookies > .buttons .btn { padding-left: 12px; padding-right: 12px }
  .cookies.active .buttons { flex: 0 1 auto }
  .cookies:not(.active):not(.row) .content { padding-bottom: 0 }
  .cookies:not(.active):not(.row) .buttons { padding-top: 12px }
}

@media (min-width: 992px) {
  .cookies:not(.active) { display: flex; gap: 20px; align-items: center; justify-content: space-between }
  .cookies:not(.active) .content { padding-right: 0 }
  .cookies:not(.active) .buttons { padding-left: 0; width: auto }
  .cookies:not(.active) > p { margin-bottom: 0 }
  .cookies > .buttons { white-space: nowrap }
  .cookies:not(.active) > .buttons > .btn { min-width: 33.33% }

  .cookies.active { border-radius: var(--radius); left: 50%; top: 50%; transform: translate(-50%, -50%); width: 100%; max-width: 600px; height: 572px; max-height: 100vh }
}`
}</style>
      {
        settings &&
        <div className={'shadow'}/>
      }
      <div className={'cookies' + (settings ? ' active' : '') + (['C', 'D'].includes(A79.value) ? ' row' : '')}>
        {
          settings
            ?
            <>
              <div className={'header w-100'}>
                <Button variant={'link'} className={'back close'} style={{margin: 0}} aria-label={'Close'}
                        onClick={() => setSettings(false)}>
                  <img width={12} height={12} src={'/static/img/icon/close.svg'} alt={'x'}/>
                </Button>
                <h3>{t('title')}</h3>
              </div>

              <div className={'content pb-0'}>
                <div className={'scrollable items gap-2 w-100'} onScroll={handleScroll}>
                  <p className={'pre-line small'}>
                    <Trans i18nKey={'text3'} t={t}>
                      We use cookies to help you navigate efficiently and perform certain
                      funclions. You'll find detailed information about all cookies under each consent category below.

                      The Necessary cookies are stored on your browser as they are essential for enabling the basic
                      functionalities of the site. You can choose to enable or disable some of all of these cookies but
                      disabling some of them may affect your browsing experience.

                      You can learn more about our identity, how to contact us, and how we handle your personal data in
                      our <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'privacy'} target={'_blank'}
                             className={'link nowrap'}>Privacy Policy</a>
                    </Trans>
                  </p>
                  <hr style={{margin: '20px 0'}}/>
                  <div className={'stack gap-5'}>
                    {Object.entries(t('list', {returnObjects: true})).map(([key, {header, desc}]) =>
                      <div key={key}>
                        <div className={'row wide mb-1'}>
                          <h3>{header}</h3>
                          <Switcher checked={consents.includes(CookieEnum[key])} disabled={key === 'necessary'}
                                    onChange={(checked) => handleChange(CookieEnum[key], checked)}/>
                          {
                            // key === 'necessary'
                            //   ? <strong style={{color: '#72A362'}}>Always Active</strong>
                            //   : <Switcher checked={consents.includes(CookieEnum[key])}
                            //               onChange={(checked) => handleChange(CookieEnum[key], checked)}/>
                          }
                        </div>
                        <p className={'small'}>{desc}</p>
                      </div>
                    )}
                  </div>
                </div>
                {
                  fading &&
                  <div className={'fading'}/>
                }
              </div>
            </>
            :
            <p className={'content'} style={A79.value === 'C' ? {fontSize: 10, lineHeight: '15px'} : {fontSize: 12}}>
              {t('text2')}
              &nbsp;
              {
                // (A79.value === 'C') &&
                // <span role={'button'} className={'link'} onClick={() => setSettings(true)}>Cookies Settings</span>
              }
            </p>
        }
        <div className={'buttons items gap-5 w-100 '}>
          {
            settings
              ?
              <>
                {
                  // A79.value === 'A' &&
                  <Button variant={'secondary'} style={{flex: 1}} onClick={() => handleCookies(false)}>{t('rejectAll')}</Button>
                }
                <Button variant={'secondary'} style={{flex: 1}} onClick={() => handleSave()}>{t('save')}</Button>
              </>
              : (
                A79.value === 'B' &&
                <Button variant={'secondary'} className={'w-auto'} onClick={() => setSettings(true)}>{t('settings')}</Button>
              )
          }
          {
            A79.value === 'D' && !settings
              ?
              <div className={'items gap-2 w-100 nowrap'}>
                <Button variant={''} style={{color: '#B5BDCC'}} onClick={() => setSettings(true)}>{t('customize')}</Button>
                <Button variant={'gold'} onClick={() => handleCookies(true)}>{t('acceptAll')}</Button>
              </div>
              : <Button variant={'gold'} className={'nowrap'} style={!settings ? {flex: 1} : {}}
                        onClick={() => handleCookies(true)}>{t('acceptAll')}</Button>
          }
        </div>
      </div>
    </>
  )
}